import { Check } from 'assets/icons';
import Tooltips from 'components/tooltips/Tooltips';

// The check in the top right corner of a done appointment, in the planning and the home agenda.
const AppointmentDoneSign = () => (
  <span className="absolute right-1 top-1">
    <Tooltips text="Rendez-vous fait" placement="top">
      <span role="img" aria-label="Rendez-vous fait" className="flex text-gray-900">
        <Check wh={16} color="currentColor" />
      </span>
    </Tooltips>
  </span>
);

export default AppointmentDoneSign;
